import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Spin, message } from 'antd';
import { useParams, useHistory } from 'react-router-dom';
import login from '../../Actions/login';
import license from '../../Actions/license';
import auth from '../../auth';
import FetchByObjectConfig from '../../Helpers/FetchByObjectConfig';

const { updateLoginStatus } = login.actions;
const { getLicenseData, getLicensesHistorical, getBalanceData } = license.actions;

function TokenAuthenticate(props) {
    const { token } = useParams();
    const history = useHistory();

    useEffect(() => {
        if (token) {
            authenticateWithToken(token);
        } else {
            message.error('Token no proporcionado');
            history.push('/');
        }
    }, []);

    const authenticateWithToken = async (authToken) => {
        try {
            // Guardar token temporalmente para que FetchByObjectConfig lo use
            const tempExpiration = new Date(Date.now() + 60000); // 1 min temporal
            auth.saveUserSession('tokenExpiration', authToken, tempExpiration);

            // Validar token llamando a un endpoint existente
            const config = {
                path: 'licenses',
                method: 'GET'
            };
            const response = await FetchByObjectConfig(config);

            // Verificar si la respuesta indica error
            if (response && response.status === 'error') {
                throw new Error('Token inválido');
            }

            // Si llegamos aquí sin error, el token es válido
            // Guardar con expiración real (misma que login normal ~24h)
            const expirationDate = new Date(Date.now() + 24 * 60 * 60 * 1000);
            auth.saveUserSession('tokenExpiration', authToken, expirationDate);

            // Actualizar estado de Redux
            props.updateLoginStatus({ isLogged: true });

            // Cargar datos del usuario
            props.getLicenseData();
            props.getLicensesHistorical();
            props.getBalanceData();

            message.success('Sesión iniciada correctamente', 3);
            history.push('/portal');

        } catch (error) {
            // Limpiar token inválido
            auth.clearStorages();
            message.error('Token inválido o expirado', 5);
            history.push('/');
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column'
        }}>
            <Spin size="large" />
            <p style={{ marginTop: '20px' }}>Validando sesión...</p>
        </div>
    );
}

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({
        updateLoginStatus,
        getLicenseData,
        getLicensesHistorical,
        getBalanceData
    }, dispatch)
});

export default connect(null, mapDispatchToProps)(TokenAuthenticate);
